import dateFormat from "dateformat";

export default class DateHelper {
  constructor(date) {
    // check possibility to parse date(String) in Firefox
    if (typeof date === "string" && Number.isNaN(Date.parse(date))) {
      console.error("Invalid Date");
    }

    const dt = new Date(date);

    this.year = dt.getUTCFullYear();
    this.month = dt.getUTCMonth();
    this.day = dt.getUTCDate();
    this.hours = dt.getUTCHours();
    this.minutes = dt.getUTCMinutes();

    this.date = this.getDateTime();
  }

  getDateTime() {
    return Date.UTC(
      this.year,
      this.month,
      this.day,
      this.hours,
      this.minutes,
      0,
      0
    );
  }

  addDays(days) {
    this.day += days;
    this.date = this.getDateTime();
    return this;
  }

  setHours(hours) {
    this.hours = hours;
    this.date = this.getDateTime();
    return this;
  }

  subHours(hours) {
    this.hours += hours;
    this.date = this.getDateTime();
    return this;
  }

  setTime(hours, minutes) {
    this.hours = hours;
    this.minutes = minutes;
    this.date = this.getDateTime();
    return this;
  }

  format(format) {
    const date = this.getDateTime();
    return dateFormat(date, format);
  }
}



// WEBPACK FOOTER //
// ./src/utils/date.js